import React from 'react'
import { motion } from 'framer-motion'

export const LoadingScreen: React.FC = () => {
  return (
    <div className="fixed inset-0 bg-gray-950 flex items-center justify-center z-50">
      <div className="text-center space-y-4">
        <motion.div
          className="w-20 h-20 mx-auto"
          animate={{
            rotate: 360,
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "linear"
          }}
        >
          <svg viewBox="0 0 100 100" className="w-full h-full">
            <circle
              cx="50"
              cy="50"
              r="45"
              fill="none"
              stroke="url(#gradient)"
              strokeWidth="2"
              strokeLinecap="round"
              strokeDasharray="283"
              strokeDashoffset="75"
            />
            <defs>
              <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#3b82f6" />
                <stop offset="100%" stopColor="#8b5cf6" />
              </linearGradient>
            </defs>
          </svg>
        </motion.div>
        <div>
          <h2 className="text-2xl font-bold text-white">Initializing Galaxy</h2>
          <p className="text-gray-400 mt-2">Loading 3D assets...</p>
        </div>
      </div>
    </div>
  )
}